var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("学员暂未绑定网校，可手动进行绑定")]),_c('a-form',{attrs:{"form":_vm.form}},[_c('a-form-item',[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'userTxt',
          { rules: [{ required: true, message: '请输入绑定的用户' }] },
        ]),expression:"[\n          'userTxt',\n          { rules: [{ required: true, message: '请输入绑定的用户' }] },\n        ]"}],attrs:{"placeholder":"手机号/网校客户编号"}})],1)],1),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.bindCrmUser}},[_vm._v("确定绑定")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }